import { render, staticRenderFns } from "./caigouList.vue?vue&type=template&id=bef098ee&scoped=true&"
import script from "./caigouList.vue?vue&type=script&lang=js&"
export * from "./caigouList.vue?vue&type=script&lang=js&"
import style0 from "./caigouList.vue?vue&type=style&index=0&id=bef098ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef098ee",
  null
  
)

export default component.exports